<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="FinanceHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            费控系统
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <div v-for="item in dataList1" :key="item.id">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            dataList1: [
                {
                    title: "1. 事前费用申请操作流程",
                    id: "12"
                },
                {
                    title: "2. 借款操作流程",
                    id: "13"
                },
                {
                    title: "3. 事后费用报销操作流程",
                    id: "14"
                },
                {
                    title: "4. 发票查验及上传报销",
                    id: "15"
                }
            ],
        };
    },
    methods: {
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"111"}})
        },
        addGetContent(i) {
            if (i == 12) {
                this.$router.push({name: 'Finance2',params: {code: "12"}});
            } else if (i == 13) {
                this.$router.push({name: 'Finance3',params: {code: "13"}});
            } else if (i == 14) {
                this.$router.push({name: 'Finance4',params: {code: "14"}});
            } else if (i == 15) {
                this.$router.push({name: 'Finance5'});
            }
        },
    }
};
</script>

<style scoped>
.box-labour {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}
.box-box {
    background: rgba(244, 244, 244, 1);
}
.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.issueContent {
    width: 90%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
    border-radius: 10px;
    overflow: hidden;
}

.issueContent div {
    width: 100%;
    height: 56px;
    border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
    width: 86%;
    float: left;
    color: #838383;
    margin: 18px 0 18px 10px;
}

.issueContent div .ImgClassDian {
    width: 18px !important;
}

.issueContent div .titleCotent {
    width: 80% !important;
    margin-left: 24px !important;
    font-size: 15px;
}

.issueContent div img {
    width: 21px;
    float: right;
    margin: 18px 10px 18px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Finance/finance.vue